/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { PropsWithChildren } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	contentWrapper: {
		paddingTop: token('space.050'),
		paddingRight: token('space.050'),
		paddingBottom: token('space.050'),
		paddingLeft: token('space.050'),
	},
	card: {
		display: 'flex',
		flexDirection: 'column',
		gap: token('space.150'),
		paddingTop: token('space.150'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.200'),
		borderRadius: token('radius.large'),
		border: `${token('border.width')} solid ${token('color.border')}`,
	},
});

export const EntityCard = ({ children }: PropsWithChildren): JSX.Element => (
	<Box xcss={styles.contentWrapper}>
		<Box xcss={styles.card}>{children}</Box>
	</Box>
);
